// The upgrade funnel's browser events, in one place.
//
// Browser events record INTENT — saw the paywall, clicked a button. Outcomes
// (blocked, paid, abandoned at Stripe) are server events, named in
// api/src/analytics/events.ts and backend/api/Services. A funnel's last step is
// always a server event: a tab can close or block analytics, a webhook can't.
//
// Renaming one of these breaks every saved insight that uses it, so don't.

export const UPGRADE_CLICKED = "upgrade_clicked";
export const UPGRADE_PAGE_VIEWED = "upgrade_page_viewed";
export const PRO_PAYWALL_SHOWN = "pro_paywall_shown";
/** The plans dialog closed without a checkout (close, Not now, backdrop, Esc). */
export const PRO_PAYWALL_DISMISSED = "pro_paywall_dismissed";
export const CHECKOUT_CLICKED = "checkout_clicked";
/** /upgrade/success loaded: the buyer came back from Stripe. */
export const CHECKOUT_COMPLETED = "checkout_completed";
